export const useDataViewTableFields = () => {

    const fields = [
        {
            name: 'order_date',
            label: 'Date'
        },
        {
            name: 'site',
            label: 'Site'
        },
        {
            name: 'material_description',
            label: 'Material'
        },
        {
            name: 'ewc_code',
            label: 'EWC Code'
        },
        {
            name: 'quantity',
            label: 'Qty.'
        },
        {
            name: 'unit_of_measure',
            label: 'Unit'
        },
        {
            name: 'recycled',
            label: 'Recycled'
        },
        {
            name: 'rdf',
            label: 'RDF'
        },
        {
            name: 'landfill',
            label: 'Landfill'
        },
        {
            name: 'vehicle_reg',
            label: 'Vehicle'
        },
        {
            name: 'movement_type',
            label: 'Movement'
        },
        {
            name: 'equipment_type',
            label: 'Container'
        },
        {
            name: 'project_number',
            label: 'Project Number'
        },
        {
            name: 'project_name',
            label: 'Project Name'
        },
        {
            name: 'carrier_name',
            label: 'Carrier Name'
        },
        {
            name: 'activity',
            label: 'Activity'
        },
        {
            name: 'material_category',
            label: 'Material Category'
        },
        {
            name: 'waste_facility',
            label: 'Waste Facility'
        },
        {
            name: 'aggregates',
            label: 'Aggregates'
        },
        {
            name: 'asphalt',
            label: 'Asphalt'
        },
        {
            name: 'bricks',
            label: 'Bricks'
        },
        {
            name: 'bulkyWaste',
            label: 'Bulky Waste inc POPs'
        },
        {
            name: 'canteenOffice',
            label: 'Canteen'
        },
        {
            name: 'concrete',
            label: 'Concrete'
        },
        {
            name: 'floorCoverings',
            label: 'Floor Covering'
        },
        {
            name: 'glass',
            label: 'Glass'
        },
        {
            name: 'greenWaste',
            label: 'Green Waste'
        },
        {
            name: 'gypsum',
            label: 'Gypsum'
        },
        {
            name: 'hazNonConform',
            label: 'Haz Non Conformance'
        },
        {
            name: 'insulation',
            label: 'Insulation'
        },
        {
            name: 'liquids',
            label: 'Liquids'
        },
        {
            name: 'mechTreated',
            label: 'Mech Treated'
        },
        {
            name: 'metals',
            label: 'Metal'
        },
        {
            name: 'nonHazNonConform',
            label: 'Non Haz Non Conformance'
        },
        {
            name: 'other',
            label: 'General Landfill'
        },
        {
            name: 'packagingPlastic',
            label: 'Packaging Plastic'
        },
        {
            name: 'packagingCard',
            label: 'Packaging Card'
        },
        {
            name: 'paper',
            label: 'Paper'
        },
        {
            name: 'plastic',
            label: 'Plastic'
        },
        {
            name: 'plasticNonRecyclable',
            label: 'Plastic Non-Recyclable'
        },
        {
            name: 'soils',
            label: 'Soils'
        },
        {
            name: 'tilesCeramics',
            label: 'Tiles'
        },
        {
            name: 'weee',
            label: 'WEEE'
        },
        {
            name: 'woodNonPackaging',
            label: 'Timber'
        },
        {
            name: 'woodPackaging',
            label: 'Pallets'
        },
        {
            name: 'tyres',
            label: 'Tyres'
        },
        {
            name: 'wasteCarbon',
            label: 'kgCO2e from Waste Generated'
        },
        {
            name: 'transportCarbon',
            label: 'kgCO2e from Transport'
        },
        {
            name: 'totalCarbon',
            label: 'Total kgCO2e'
        },
        {
            name: 'jobDistance',
            label: 'Job Distance'
        },
        {
            name: 'treeCount',
            label: 'Tree Offset Counter'
        }
    ]

    const getField = (name) => {
        return fields.find((field) => field.name === name)
    }

    return { fields, getField }

}
